<template>
  <AddToListSheetInner
    :title="title"
    :title-info="titleInfo"
    :user-title-info="userTitleInfo"
    @close="emit('close')" />
</template>

<script setup>
import AddToListSheetInner from '@/components/Sheets/AddToListSheetInner.vue'

defineProps({
  title: {
    type: Object,
    default: null
  },
  titleInfo: {
    type: Object,
    default: null
  },
  userTitleInfo: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['close'])
</script>
